
import Vue from 'vue'
import { Currency } from '@/components'

export default Vue.extend({
   name: 'OrderTotals',
   computed: {
      hasStoreCredit(): boolean {
         return this.$store.state.modelData.HasStoreCreditAvailable
      },
      storeCredit(): boolean {
         return this.$store.state.modelData.StoreCreditAvailable
      },
      currencyCode(): string {
         return this.$store.getters.currencyCode
      },
   },
   components: {
      Currency,
   },
})
